<script>
import { mapGetters, mapState } from "vuex";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Footer from "@/components/Footer";

export default {
  // Included components
  components: {
    FontAwesomeIcon,
    Footer,
  },

  data() {
    return {
      // Whether or not the sidebar is open
      open: false,
    };
  },

  computed: {
    // Mapped state values
    ...mapGetters(["can"]),
    ...mapState(["user"]),
  },

  methods: {
    // Return whether the route starts with a given path
    path(path) {
      return this.$route.path.startsWith(path);
    },
  },
};
</script>

<template>
  <div class="Outer">
    <b-container fluid class="Main-nav pt-3" :open="open">
      <b-nav vertical>
        <b-nav-item
          v-if="this.user.isStaffAdmin"
          active-class="active"
          to="/contracts"
          class="mb-2"
        >
          Contracts
        </b-nav-item>
        <b-nav-item
          v-if="this.user.isStaffAdmin"
          active-class="active"
          to="/contract-facilities"
          class="mb-2"
        >
          Contract Facilities
        </b-nav-item>
      </b-nav>
    </b-container>
    <div class="Content" @mousedown="open = false">
      <b-container fluid class="Breadcrumbs">
        <b-breadcrumb>
          <b-link class="Bars">
            <FontAwesomeIcon
              icon="bars"
              size="lg"
              class="mr-3"
              @click="open = true"
            />
          </b-link>
          <slot name="breadcrumbs" />
        </b-breadcrumb>
      </b-container>
      <b-container fluid class="p-3 Inner">
        <slot />
      </b-container>
      <Footer />
    </div>
  </div>
</template>

<style scoped>
.Outer {
  position: relative;
  width: 100%;
  height: 100%;
}

.Main-nav {
  width: 15rem;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  transition: width 0.3s, left 0.3s;
  position: fixed;
  z-index: 10;
  top: 4rem;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  transform: translate3d(0, 0, 0);
}

.Content {
  margin-left: 15rem;
  width: calc(100% - 15rem);
  z-index: 9;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.Breadcrumbs .Bars {
  display: none;
}

.Breadcrumbs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.breadcrumb {
  background-color: transparent;
  border: none;
  margin: 0;
  padding-left: 0;
  padding-right: 0;
}

@media (max-width: 1024px) {
  .Breadcrumbs .Bars {
    display: block;
  }

  .Main-nav {
    display: none;
  }

  .Main-nav[open] {
    display: block;
    background: linear-gradient(
      rgb(249, 250, 255) 0%,
      rgba(255, 255, 255) 1000px
    );
  }

  .Main-nav[open] ~ .Content {
    filter: blur(1.5px);
    overflow: hidden;
    height: 100%;
  }

  .Content {
    margin-left: 0rem;
    width: calc(100% - 2px);
    right: 1rem;
    z-index: 9;
  }
}

.Bars {
  color: rgba(0, 0, 0, 0.7);
}

.Inner {
  flex: 1;
}
</style>
